export default __webpack_public_path__ + "static/checkin-e0b3c9a6b6e38603bb55946d32e68340.png";